// extracted by mini-css-extract-plugin
export default {"avatar":"avatar---Hf8r_","loader":"loader---V4kfN","spinloader":"spinloader---PXKeA","spinlogo":"spinlogo---B2cKw"};